export const contractAddress = {
    USDT: '0x55d398326f99059fF775485246999027B3197955',
    pillMLM: '0xA267e31aABB06959BB466059E32B65310dcFf215',
    Owner: '0x5CD29223f636C0CE29CDa9ED0C89Ccb2D9F3E5d5',
    withdrawCashFlow:'0x1a0EDEE5f467E31A9341B887b93c3156D844D388'

};
